






import Vue from 'vue';

export default Vue.extend({
  name: 'HMVueEditorPreview',
  props: {
    html: {
      type: String,
      default: '',
    },
  },
});
